import HowDoesThisWorkPopUp from './HowDoesThisWorkPopUp';
import './HowDoesThisWorkPopUp.css';

export default HowDoesThisWorkPopUp;



// WEBPACK FOOTER //
// ./src/pages/Account/components/HowDoesThisWorkPopUp/index.js